import devtoolsDetector from 'devtools-detector';
import { useState, useEffect } from 'react';

function useIsDevToolsOpen(options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$interval = _options.interval,
    interval = _options$interval === void 0 ? 500 : _options$interval,
    _options$enabled = _options.enabled,
    enabled = _options$enabled === void 0 ? true : _options$enabled;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  useEffect(function () {
    if (!enabled) return;
    devtoolsDetector.addListener(setIsOpen);
    devtoolsDetector.setDetectDelay(interval);
    devtoolsDetector.launch();
    return function () {
      devtoolsDetector.stop();
      devtoolsDetector.removeListener(setIsOpen);
    };
  }, [enabled, interval]);
  return isOpen;
}

export default useIsDevToolsOpen;
//# sourceMappingURL=react-devtools-detector.esm.js.map
